import moment from "moment"
import { useForm } from "react-hook-form"
import { getInputType } from "../AssistanceLinkFormStepsScreen"
import { Button, ButtonLoader } from "../../components/Button"
import { EvidenceBox, MessageBox } from "../../components/MessageBox"
import { AnswerBadge } from "../../components/AnswerBadge"
import { ModalAddForm } from "../../components/ModalAddStepForm"
import { Input, Label, SelectInput } from "../../components/Form"
import { InfoTooltip } from "../../components/Tooltip"
import { ModalBody, ModalFooter, ModalHeader, ModalPanel } from "../../components/Modal"
import StepProgressBar from "../../components/StepProgressBar"
import { DatePicker } from "../../components/DatePicker"
import { EvaluationButton } from "../EvaluationAssistanceScreen"
import SuccessFileIcon from "../../assets/icons/success_file.svg"
import "./styles.scss"
import { memo, useState, useEffect } from "react"
import { IoMdCheckmark } from "react-icons/io"
import { LoadingWithLabel, Spinner } from "../../components/Loading"
import { isMobile } from "react-device-detect"
import { PiPencilSimple } from "react-icons/pi"

const TitleAsComponent = ({ answer, index }) => {
  const content = `${index + 1}. ${answer.title}`

  return (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <div
        dangerouslySetInnerHTML={{ __html: content }}
        data-tip={answer.title || "No description available"}
      />
      {answer?.isLinkedToAssistance && (
        <InfoTooltip
          info="Pergunta enviada via formulário"
          icon="fi-rs-paper-plane"
          iconColor="FFC103"
        />
      )}
    </div>
  )
}

const StepQuestions = memo(
  ({
    steps,
    handleOpenLinkMessage,
    handleChange,
    values,
    onChangeFile,
    uploadedFiles,
    removeFile,
    loadingProcessImage,
    removePinnedMessage,
    loadLocation,
    getNewLoc,
    handleChangeGeoLocation,
    geolocation,
    handleRemoveEvidence
  }) => {
    const { register, control } = useForm({
      mode: "onChange",
    })

    return (
      <div className="steps__container">
        <div style={{ marginBottom: 8 }}>
          <Label label="Localização ao preencher formulário" />
          <Input
            placeholder="Localização"
            onChange={(e) => handleChangeGeoLocation(e)}
            value={geolocation || ""}
            hasFocus={false}
            handleClick={(e) => getNewLoc(null)}
            iconClick={"fi fi-rs-bullseye-pointer"}
          />
        </div>
        {Array.isArray(steps) &&
          steps.map((step) => (
            <>
              <div className="step__container" key={step.id}>
                <div className="form_header">
                  <h3>Etapa: {step.title}</h3>
                </div>
                {Array.isArray(step.questions) &&
                  step.questions?.map((answer, index) => {
                    const answerValues =
                      Array.isArray(values[answer?.conditionalQuestion]) &&
                      values[answer?.conditionalQuestion]?.map((item) => item?.value)
                    const hasMatchingValue =
                      Array.isArray(answerValues) &&
                      answerValues?.some((value) => answer?.conditionalAnswer?.includes(value))
                    const evidences = values[`${answer?.name}-evidence`] || [];
                    const hasEvidences = Array.isArray(evidences) && evidences.filter(Boolean).length > 0;
                    return !answer?.isConditional ||
                      ((values[answer?.conditionalQuestion]?.value ||
                        values[answer?.conditionalQuestion]) &&
                        answer?.conditionalAnswer
                          ?.split("|")
                          .includes(
                            values[answer?.conditionalQuestion]?.value ||
                            values[answer?.conditionalQuestion],
                          )) ||
                      hasMatchingValue ? (
                      <>
                        <div className="question-inputs" key={answer?.name}>
                          <div className="labelContainer">
                            <Label
                              className="questionTitle"
                              label={<TitleAsComponent {...{ answer, index }} />}
                              subtitle={answer.type !== "table" ? answer.info : ""}
                              componentInTitle={true}
                            />
                          </div>
                          <div className="question_details">
                            <div className="input_field">
                              {getInputType(
                                { ...answer, id: answer?.name },
                                handleChange,
                                onChangeFile,
                                uploadedFiles,
                                removeFile,
                                loadingProcessImage,
                                control,
                                register,
                                values,
                                loadLocation,
                                getNewLoc,
                              )}
                            </div>
                            <div className="add_button__container">
                              <InfoTooltip
                                info="Adicionar evidência"
                                trigger="hover"
                                children={
                                  <div
                                    className="add_button"
                                    onClick={() => handleOpenLinkMessage(answer)}
                                  />
                                }
                              />
                            </div>
                          </div>
                          {hasEvidences &&
                            <EvidenceBox
                              hasActions={true}
                              questionId={answer?.name}
                              handleRemoveEvidence={handleRemoveEvidence}
                              evidences={values[`${answer?.name}-evidence`]}
                            />}
                          {values[`${answer?.name}-messages`]?.length > 0 &&
                            values[`${answer?.name}-messages`].map((message) => (
                              <MessageBox
                                message={message}
                                hasActions
                                removePinnedMessage={(msgId) =>
                                  removePinnedMessage(answer?.name, msgId)
                                }
                              />
                            ))}
                        </div>
                      </>
                    ) : (
                      <></>
                    )
                  })}
              </div>
            </>
          ))}
      </div>
    )
  },
)

const QuestionSection = ({ type, title, answer }) => {
  return (
    <div className="question_type__container">
      <p className="question__header">{title}</p>
      <div className="question_answer">
        {Array.isArray(answer) &&
          answer.map((item, idx) =>
            type === "text" ? (
              answer
            ) : type === "image" ? (
              <img src={item} alt={`Evidência ${idx + 1}`} />
            ) : (
              <AnswerBadge answer={item} />
            ),
          )}
      </div>
    </div>
  )
}

const ModalReturnAssistance = ({
  modalReturnIsOpen,
  handleCloseReturnModal,
  handleConfirmReturn,
  currentStep,
  goToPreviousStep,
  goToNextStep,
  handleChangeEvaluationValue,
  evaluationValue,
  handleChangeScheduleReturn,
  handleSave,
  loadingSendEvaluation,
  loading,
  removeEvaluationStep,
}) => {
  return (
    <>
      <ModalPanel modalIsOpen={modalReturnIsOpen}>
        <ModalHeader closeModal={handleCloseReturnModal} hasContent={true}>
          {currentStep === 1 ? (
            <h3>Esse atendimento precisa de retorno ?</h3>
          ) : currentStep === 2 || currentStep === 3 ? (
            <div className="header-button">
              <button className="back-button" onClick={goToPreviousStep}>
                <i className="fi fi-sr-arrow-small-left" />
              </button>
              <label className="title">Voltar</label>
            </div>
          ) : (
            <></>
          )}
        </ModalHeader>
        <ModalBody className="modal-return-assistance">
          <StepProgressBar currentStep={currentStep} />
          <div className="modal-return-container">
            {currentStep === 1 ? (
              <>
                <Label label="Dê um titulo para este retorno" />
                <Input
                  placeholder="Digite aqui"
                  onChange={(e) => handleChangeScheduleReturn("title", e.target.value)}
                />
                <Label label="Data do retorno" />
                <DatePicker
                  format={"DD/MM/YYYY"}
                  //value={values[row?.formQuestionId || row?.title]}
                  className="input-date"
                  onChange={(value) => handleChangeScheduleReturn("dateToAdd", value)}
                  placeholder="DD/MM/AAAA"
                />
              </>
            ) : currentStep === 2 ? (
              <div className="send-evaluation-message-content">
                <div className="message">
                  <span>Deixe sua avaliação para esse agendamento</span>
                </div>
                <div className="evaluation-content-buttons">
                  <EvaluationButton
                    id="1"
                    emoji="😞"
                    label="Muito Ruim"
                    selectedOption={evaluationValue}
                    handleChange={handleChangeEvaluationValue}
                  />
                  <EvaluationButton
                    id="2"
                    emoji="😕"
                    label="Ruim"
                    selectedOption={evaluationValue}
                    handleChange={handleChangeEvaluationValue}
                  />
                  <EvaluationButton
                    id="3"
                    emoji="😐"
                    label="Regular"
                    selectedOption={evaluationValue}
                    handleChange={handleChangeEvaluationValue}
                  />
                  <EvaluationButton
                    id="4"
                    emoji="🙂"
                    label="Bom"
                    selectedOption={evaluationValue}
                    handleChange={handleChangeEvaluationValue}
                  />
                  <EvaluationButton
                    id="5"
                    emoji="😃"
                    label="Muito Bom"
                    selectedOption={evaluationValue}
                    handleChange={handleChangeEvaluationValue}
                  />
                </div>
              </div>
            ) : currentStep === 3 ? (
              <>
                <div className="send-evaluation-message-content">
                  <div className="message">
                    <span>Deseja enviar avaliação para o produtor?</span>
                  </div>
                </div>
              </>
            ) : currentStep === 4 ? (
              <>
                <div className="success__container">
                  <img alt="Atendimento Finalizado" src={SuccessFileIcon} />
                  <span className="title">Atendimento Finalizado!</span>
                  <span className="Description">
                    {`${!removeEvaluationStep
                      ? "O atendimento foi encerrado. Enviamos ao produtor uma solicitação para avaliar este atendimento."
                      : ""
                      }`}
                  </span>
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </ModalBody>
        <ModalFooter className="modal-return-footer">
          {currentStep === 1 ? (
            <>
              <Button
                classButton="assistance-confirm"
                label="Não"
                variant="outline"
                handleClick={() => handleConfirmReturn(false)}
              />
              <Button
                classButton="assistance-confirm"
                label="Sim"
                handleClick={() => handleConfirmReturn(true)}
              />
            </>
          ) : currentStep === 2 ? (
            <Button
              classButton="assistance-confirm"
              label="Próximo"
              handleClick={() => goToNextStep()}
            />
          ) : currentStep === 3 ? (
            <>
              <Button
                classButton="assistance-confirm"
                label="Não"
                variant="outline"
                isDisabled={loadingSendEvaluation || loading}
                handleClick={(e) => handleSave(e, false)}
              />
              <ButtonLoader
                classButton="assistance-confirm"
                label="Sim"
                loading={loadingSendEvaluation}
                messageProcess="Salvando..."
                handleClick={(e) => handleSave(e, true)}
              />
            </>
          ) : (
            <></>
          )}
        </ModalFooter>
      </ModalPanel>
    </>
  )
}

const HeaderPage = ({
  assistanceTitleEdit,
  register,
  handleAssistanceTitleEdit, // <- Função correta
  watch,
  assistanceTitle,
  loadingSteps,
  contextDetails,
  assistanceCategory,
  isUserAdmin,
  handleRemoveScheduledAssistance,
}) => {
  const [isEditingTitle, setIsEditingTitle] = useState(false);
  const [editedTitle, setEditedTitle] = useState(assistanceTitle || "");

  useEffect(() => {
    setEditedTitle(assistanceTitle || "");
  }, [assistanceTitle]);

  const handleConfirmEditTitle = () => {
    try {
      handleAssistanceTitleEdit(editedTitle);
      setIsEditingTitle(false);
    } catch (error) {
      console.error(error);
    }
  };


  return (
    <header>
      <div className="header_text_box">
        <div className="header_text_box-input-edit">
          <InfoTooltip
            info={assistanceTitle || "Registro de Atendimento"}
            trigger="hover"
          >
            {loadingSteps && !assistanceTitle ? (
              <Spinner size="small" />
            ) : isEditingTitle ? (
              <div style={{ display: "flex", alignItems: "center", gap: "6px", minWidth: "200px", width: "300px" }}>
                <Input
                  // placeholder="Localização"
                  onChange={(e) => setEditedTitle(e.target.value)}
                  value={editedTitle}
                  hasFocus={false}
                  isWhite={true}
                />
                <button
                  onClick={handleConfirmEditTitle}
                  className="edit_title_button"
                  style={{
                    background: "transparent",
                    border: "none",
                    cursor: "pointer",
                    padding: 0,
                    display: "flex",
                    alignItems: "center",
                    marginLeft: "5px",
                  }}
                >
                  <i
                    class=
                    "fi fi-rr-check"
                  ></i>
                </button>
              </div>
            ) : (
              <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                <h3>{assistanceTitle}</h3>
                <div style={{ display: "flex", gap: "8px" }}>
                  <button
                    onClick={() => setIsEditingTitle(true)}
                    className="edit_title_button"
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <PiPencilSimple size={18} weight="regular" />
                  </button>
                  {isUserAdmin && (
                    <button
                      onClick={() => {
                        if (window.confirm("Tem certeza que deseja excluir este atendimento? Esta ação não pode ser desfeita.")) {
                          handleRemoveScheduledAssistance();
                        }
                      }}
                      className="delete_title_button"
                      style={{
                        background: "transparent",
                        border: "none",
                        cursor: "pointer",
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        color: "#dc3545",
                      }}
                    >
                      <i className="fi fi-rr-trash" style={{ fontSize: "16px" }}></i>
                    </button>
                  )}
                </div>
              </div>
            )}
          </InfoTooltip>
        </div>
        <h5>
          {contextDetails && contextDetails?.dateToAdd ? (
            <>
              {assistanceCategory === "closed" ? "Finalizado em: " : "Agendado para:"}
              <span>
                {moment
                  .utc(
                    assistanceCategory === "closed"
                      ? contextDetails?.updatedAt
                      : contextDetails?.dateToAdd,
                  )
                  .format("DD/MM/YYYY")}
              </span>
            </>
          ) : (
            ""
          )}
        </h5>
      </div>
    </header>
  );
};


export const AssistancePlanContextScreen = ({
  contextDetails,
  assistanceTitle,
  modalAddFormIsOpen,
  setModalAddFormIsOpen,
  handleSaveDraft,
  handleOpenLinkMessage,
  handleCloseFormModal,
  handleAddSteps,
  handleChangeChecked,
  handleActiveIndicator,
  stepsToRespond,
  indicatorTabsOptions,
  formSteps,
  checkedSteps,
  handleChange,
  values,
  handleSave,
  contextData,
  formId,
  onChangeFile,
  uploadedFiles,
  removeFile,
  loadingProcessImage,
  removePinnedMessage,
  modalReturnIsOpen,
  setModalReturnIsOpen,
  handleCloseReturnModal,
  handleConfirmReturn,
  sendEvaluationMessage,
  setSendEvaluationMessage,
  currentStep,
  goToNextStep,
  goToPreviousStep,
  handleChangeEvaluationValue,
  evaluationValue,
  handleChangeScheduleReturn,
  loading,
  loadingSendEvaluation,
  assistanceCategory,
  technicalList,
  isUserAdmin,
  isUserManager,
  currentUser,
  dataToUpdate,
  handleChangeDataToUpload,
  loadLocation,
  getNewLoc,
  handleChangeSelectedProject,
  selectedProject,
  handleRemoveScheduledAssistance,
  removeEvaluationStep,
  projectOptions,
  assistanceTitleEdit,
  handleAssistanceTitleEdit,
  register,
  getValues,
  watch,
  loadingSteps,
  loadingTechnical,
  category,
  handleChangeGeoLocation,
  geolocation,
  handleRemoveEvidence
}) => {

  const showDeleteButton =
    (contextDetails?.responsible === currentUser || isUserAdmin || isUserManager) &&
    assistanceCategory === "schedule"

  return (
    <>
      <div className="plan_context__container">
        {!formId ? (
          <HeaderPage
            {...{
              assistanceTitleEdit,
              register,
              handleAssistanceTitleEdit,
              watch,
              assistanceTitle,
              loadingSteps,
              contextDetails,
              assistanceCategory,
              isUserAdmin,
              handleRemoveScheduledAssistance,
            }}
          />
        ) : (
          <></>
        )}
        <div
          className={`body_form__container${formId
            ? ` isForm-tab ${isMobile ? ` isForm-tab-mobile` : ``}`
            : ` isAssistance-tab ${isMobile ? ` isAssistance-tab-mobile` : ``}`
            }`}>
          <>
            {assistanceCategory && assistanceCategory !== "startedForms" ? (
              <>
                <div className="edit_form__container">
                  <div className="edit_form_left">
                    <div className="header_action_box">
                      <Label noMargin label="Data do atendimento?" />
                      <DatePicker
                        format={"DD/MM/YYYY"}
                        value={moment.utc(dataToUpdate.dateToAdd).format("DD/MM/YYYY")}
                        onChange={(value) => handleChangeDataToUpload("dateToAdd", { value })}
                        disabled={
                          (!isUserAdmin && !isUserManager && assistanceCategory === "schedule") ||
                          assistanceCategory === "closed"
                        }
                      />
                    </div>
                  </div>
                  {category === "new" &&
                    projectOptions &&
                    projectOptions?.length > 1 &&
                    !stepsToRespond?.length && (
                      <div className={`header_action_box_project`}>
                        <Label label="Para qual projeto deseja fazer este registro ? *" noMargin />
                        <SelectInput
                          isOverModal={true}
                          options={projectOptions}
                          isSearchable
                          value={selectedProject}
                          handleChange={handleChangeSelectedProject}
                        />
                      </div>
                    )}
                  <div
                    className={`header_action_box_tec ${!isUserAdmin && !isUserManager ? "disabled" : ""
                      }`}
                    key={technicalList?.length}>
                    <Label label="Quem realizará o atendimento?" noMargin />
                    <SelectInput
                      isOverModal={true}
                      options={technicalList}
                      placeholder={loadingTechnical ? "Buscando..." : "Selecione um técnico"}
                      isSearchable
                      isDisabled={(!isUserAdmin && !isUserManager) || loadingTechnical}
                      value={dataToUpdate?.technician || {}}
                      handleChange={(value) => handleChangeDataToUpload("technician", value || {})}
                    />
                  </div>
                  {!['new', 'closed'].includes(category) && (!stepsToRespond?.length) && (
                    <Button
                      label="Adicionar Formulário"
                      onClick={() => setModalAddFormIsOpen(true)}
                    />
                  )}
                </div>
              </>
            ) : (
              <></>
            )}
          </>
          {loadingSteps && !stepsToRespond?.length > 0 ? (
            <div className="form_container">
              <LoadingWithLabel
                labelLoading="Buscando questões para responder..."
                colorSpinner="primary"
              />
            </div>
          ) : (
            <>
              {stepsToRespond && stepsToRespond?.length > 0 ? (
                <>
                  {contextDetails && contextDetails?.description ? (
                    <p>Descrição: {contextDetails?.description}</p>
                  ) : (
                    <></>
                  )}
                  <StepQuestions
                    steps={stepsToRespond}
                    handleOpenLinkMessage={(question) =>
                      handleOpenLinkMessage({ ...question, answer: values[question?.name] })
                    }
                    handleChange={handleChange}
                    values={values}
                    contextDetails={contextDetails}
                    onChangeFile={onChangeFile}
                    uploadedFiles={uploadedFiles}
                    removeFile={removeFile}
                    loadingProcessImage={loadingProcessImage}
                    removePinnedMessage={removePinnedMessage}
                    loadLocation={loadLocation}
                    getNewLoc={getNewLoc}
                    {...{
                      handleChangeGeoLocation,
                      geolocation,
                      handleRemoveEvidence
                    }}
                  />
                </>
              ) : (
                <div className="form_container">
                  <div className="form_header">
                    <h3></h3>
                    <div className="header_action_box">
                      {(loadingSteps && !stepsToRespond?.length > 0) ||
                        formId ||
                        category === "closed" ||
                        !selectedProject?.value ? (
                        <></>
                      ) : (
                        <Button
                          label="Iniciar atendimento"
                          isDisabled={!dataToUpdate?.technician}
                          color="primary"
                          handleClick={() => setModalAddFormIsOpen(true)}
                        //isDisabled={projectOptions && !selectedProject?.value}
                        />
                      )}
                    </div>
                  </div>
                  {contextDetails && contextDetails?.description ? (
                    <p>Descrição: {contextDetails?.description}</p>
                  ) : (
                    <></>
                  )}
                  {Array.isArray(contextData) && contextData.length ? (
                    <div className="form_content">
                      {contextData.map((item, idx) => (
                        <>
                          {idx === 0 &&
                            Array.isArray(item?.messageIds) &&
                            item.messageIds.map((message) => (
                              <div className="content-box">
                                <MessageBox message={message} />
                              </div>
                            ))}
                          {item?.title && (item.type === "text" || item.type === "image") && (
                            <div className="content-box">
                              <QuestionSection
                                type={item?.type}
                                title={item?.title}
                                answer={item?.value.split("|") || []}
                              />
                            </div>
                          )}
                        </>
                      ))}
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        <div
          className={`form_footer ${showDeleteButton ? "show-schedule-delete-button" : ""} ${isMobile ? `form_footer-mobile` : ``
            } ${isMobile && !formId && assistanceCategory === "closed"
              ? `finish-assistance-button-mobile`
              : ``
            }`}>
          {showDeleteButton && (
            <div className="header_action_box">
              <Button
                label="Excluir Agendamento"
                variant="ghost"
                color="danger"
                handleClick={handleRemoveScheduledAssistance}
              />
            </div>
          )}
          <div style={{ display: "flex", flexDirection: "row" }}>
            <div className={`header_action_box`}>
              {stepsToRespond && stepsToRespond?.length > 0 && (
                <ButtonLoader
                  label={!formId ? "Finalizar" : "Salvar"}
                  color="new_green"
                  loading={loading}
                  messageProcess={!formId ? "Finalizando" : "Salvando"}
                  isDisabled={projectOptions && !selectedProject}
                  handleClick={() => (formId ? handleSave() : setModalReturnIsOpen(true))}
                />
              )}
            </div>

            {assistanceCategory !== "closed" && stepsToRespond?.length && !formId ? (
              <div className="header_action_box header_action_box_button">
                <Button
                  label="Salvar informações"
                  color="new_green"
                  variant="outline"
                  handleClick={() => handleSaveDraft()}
                />
              </div>
            ) : (
              <></>
            )}
          </div>
        </div>
      </div>
      {!formId && modalReturnIsOpen && (
        <ModalReturnAssistance
          {...{
            modalReturnIsOpen,
            handleCloseReturnModal,
            handleConfirmReturn,
            sendEvaluationMessage,
            setSendEvaluationMessage,
            currentStep,
            goToNextStep,
            goToPreviousStep,
            handleChangeEvaluationValue,
            evaluationValue,
            handleChangeScheduleReturn,
            handleSave,
            loadingSendEvaluation,
            loading,
            removeEvaluationStep,
          }}
        />
      )}
      {modalAddFormIsOpen && (
        <ModalAddForm
          {...{
            modalAddFormIsOpen,
            handleCloseFormModal,
            handleActiveIndicator,
            indicatorTabsOptions,
            formSteps,
            checkedSteps,
            handleChangeChecked,
            handleAddSteps,
          }}
        />
      )}
    </>
  )
}
